// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import ArrowForward from "@store/Library/Components/Toolkit/Icons/ArrowForward";
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import constants from "@store/constants";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC } from "react";

export interface ProductListExportPriceListPresentationProps extends ExpandStyles<ProductListExportPriceListStyles> {}

export interface ProductListExportPriceListProps extends ProductListExportPriceListPresentationProps {
    label?: string;
    reportId: string;
}

export interface ProductListExportPriceListStyles {
    button?: ButtonPresentationProps;
}

const productListExportPriceListStyles: ProductListExportPriceListStyles = {
    button: {
        variant: "tertiary",
        icon: {
            src: ArrowForward,
            position: "right",
        },
    },
};

const ProductListExportPriceList: FC<ProductListExportPriceListProps> = ({
    extendedStyles,
    label,
    overridedStyles,
    reportId,
}) => {
    const styles = useExpandProps(productListExportPriceListStyles, extendedStyles, overridedStyles);
    const myReportsPageLink = usePageLinkByPageType(constants.pageType.myReports);
    const hasProducts = useAppSelector(state =>
        Boolean(getProductListDataViewProperty(state, "pagination")?.totalItemCount),
    );

    if (!hasProducts || !reportId || !myReportsPageLink?.url) {
        return null;
    }

    return (
        <Button
            {...styles.button}
            href={`${myReportsPageLink?.url}?id=${reportId}`}
            data-test-selector="exportPriceListButton"
        >
            {label || translate("Check Price List")}
        </Button>
    );
};

export default ProductListExportPriceList;
